import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationListComponent } from './notification-list.component';
import { NotificationToasterComponent } from './notification-toaster.component';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [
    NotificationListComponent,
    NotificationToasterComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    BadgeModule,
    ButtonModule,
    RouterModule,
    ToastModule,
    TagModule,
    TooltipModule,
    OverlayPanelModule
  ],
  exports: [
    NotificationListComponent,
    NotificationToasterComponent
  ],
})
export class NotificationsModule {}
